import Login from "../components/Login";
import LoginSeeker from "../components/LoginSeeker";
import LoginEmployer from "../components/LoginEmployer";
import RegisterSeeker from "../components/RegisterSeeker";
import RegisterEmployer from "../components/RegisterEmployer";
import Register from "../components/Register";
import EmailVerification from "../components/EmailVerification";
import About from "../components/About/Index";
import Home from "../components/Home/Index";
import JobSearch from "../components/JobSearch/Index";

import Contact from "../components/Contact";
import Training from "../components/Training/Index";
import TrainingDetail from "../components/Training/Show";

import Blogs from "../components/Blog/Blogs";
import BlogDetails from "../components/Blog/BlogDetails";
import JobsDetails from "../components/Jobs/JobsDetails";
import Cms_Details from "../components/Cms_Details";
import EmployerZone from "../components/EmployerZone/Index";
import CompanyProfile from "../components/Company/Profile";
import ForgotPaswword from "../components/ForgotPaswword";
import ResetPassword from "../components/ResetPassword";
import Error from "../components/Error";
import Faq from "../components/Faq/Faq";
import Cms_Page from "../components/Cms_Page";
import VerifyEmail from "../components/UserDashboard/VerifyEmail";
import ReferenceVerify from "../components/ReferenceVerify";

const frontendRoutes = [
  {
    path: "/",
    name: "Home",
    exact: true,
    component: Home,
  },
    {
    path: "/job_search",
    name: "Job Search",
    exact: true,
    component: JobSearch,
  },
  {
    path: "/employer-zone",
    name: "Employer Zone",
    exact: true,
    component: EmployerZone,
  },
  {
    path: "/verify",
    name: "Verify Email",
    exact: true,
    component: VerifyEmail,
  },
  {
    path: "/about",
    name: "About",
    exact: true,
    component: About,
  },
  {
    path: "/register",
    name: "Register",
    exact: true,
    component: Register,
  },
  {
    path: "/register-seeker",
    name: "Register Seeker",
    exact: true,
    component: RegisterSeeker,
  },
  {
    path: "/register-employer",
    name: "Register Employer",
    exact: true,
    component: RegisterEmployer,
  },
  {
    path: "/login",
    name: "Login",
    exact: true,
    component: Login,
  },
  {
    path: "/login-seeker",
    name: "Login Seeker",
    exact: true,
    component: LoginSeeker,
  },
  {
    path: "/login-employer",
    name: "Login Employer",
    exact: true,
    component: LoginEmployer,
  },
  {
    path: "/email_verification",
    name: "EmailVerification",
    exact: true,
    component: EmailVerification,
  },
  {
    path: "/forgot_password",
    name: "Forgot Password",
    exact: true,
    component: ForgotPaswword,
  },
  {
    path: "/reset_password",
    name: "Reset Password",
    exact: true,
    component: ResetPassword,
  },
  {
    path: "/faq",
    name: "FAQ",
    exact: true,
    component: Faq,
  },
  {
    path: "/contact-us",
    name: "Contact",
    exact: true,
    component: Contact,
  },
  {
    path: "/training",
    name: "Training",
    exact: true,
    component: Training,
  },
  {
    path: "/training/:slug",
    name: "Training Detail",
    exact: true,
    component: TrainingDetail,
  },
  {
    path: "/blog",
    name: "Blogs",
    exact: true,
    component: Blogs,
  },
  {
    path: "/blog/:id",
    name: "Blog Details",
    exact: true,
    component: BlogDetails,
  },
  {
    path: "/error_page",
    name: "Error",
    exact: true,
    component: Error,
  },

  {
    path: "/pages/:slug",
    name: "Pages",
    exact: true,
    component: Cms_Page,
  },
  {
    path: "/reference_verify/:reftoken",
    name: "ReferenceVerify",
    exact: true,
    component: ReferenceVerify,
  },
  {
    path: "/jobs/:slug",
    name: "Jobs Details",
    exact: true,
    component: JobsDetails,
  },
  {
    path: "/other_cms/:id",
    name: "Cms Details",
    exact: true,
    component: Cms_Details,
  },
  {
    path: "/company/:clientslug",
    name: "Company Profile",
    exact: true,
    component: CompanyProfile,
  },
];
export default frontendRoutes;